<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols='12'>
        <DataTableServer
          :datatable='tableServer'
          :on-success='successAction'
          :itemsAction='tableAction'
          :on-pagination="pagePagination"
          :on-search="getSearchPagePagination"
          :expresionSearch="exprecion"
        />
      </v-col>
      <v-col cols='12' sm='6'>
        <ViewDetails :object="object" type="Solicitud" />
      </v-col>
      <v-col cols='12' sm='6'>
        <ViewDetails :object="object" type="Movements" />
      </v-col>
    </v-row>
    <MesaAyudaDialog v-if="get_dialogMain.dialog && get_dialogMain.type == 'create'" />
    <MesaAyudaTicketsDialog
      v-if=" get_dialogMain.dialog &&
      get_dialogMain.type != 'create' &&
      get_dialogMain.type != 'addInsumos' &&
      get_dialogMain.type != 'returnedInsumos' &&
      get_dialogMain.type != 'edit'"
      :model='item'/>
    <MesaAyudaEditTicketsDialog v-if="get_dialogMain.dialog && get_dialogMain.type == 'edit'" :model='item' />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import XLSX from 'xlsx'
// import DataTable from '@/components/dataTableMain'
import DataTableServer from '@/components/tables/DataTableMainServer'
import MesaAyudaDialog from '@/components/dialog/mesaayuda/MesaAyudaDialog'
import MesaAyudaTicketsDialog from '@/components/dialog/mesaayuda/MesaAyudaTicketsDialog'
import MesaAyudaEditTicketsDialog from '@/components/dialog/mesaayuda/MesaAyudaEditTicketsDialog'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    tableServer: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', pagination: {}, code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'toCreateSolicitud', code: 'ma.store' },
          {
            title: 'Reporte',
            icon: 'mdi-cloud-download',
            color: 'light-blue lighten-1',
            code: 'ma.export-list',
            options: [
              { title: 'Reporte general', icon: 'mdi-clipboard-text', color: 'yellow darken-3', action: 'ExportTodos' }
            ]
          }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Solicitante', value: 'SolicitanteSelected', class: 'black--text' },
          { text: 'Departamento', value: 'DepartamentoSelected', class: 'black--text' },
          { text: 'Tipo Atencion', value: 'tipo_servicio.nombre', align: 'center', class: 'black--text' },
          { text: 'Tipo Actividad', value: 'Actividad', align: 'center', class: 'black--text' },
          { text: 'Estatus', value: 'Status', align: 'center', class: 'black--text' },
          { text: 'Programado', value: 'Programado', align: 'center', class: 'black--text' },
          // { text: 'Activo', value: 'Activo', align: 'center', class: 'black--text' },
          { text: '', value: 'Actions' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar Solicitud', icon: 'mdi-clipboard-edit', color: 'yellow darken-2', action: 'toEditRow', code: 'ma.solicitud.edit' },
          { title: 'Eliminar', icon: 'mdi-check-circle', color: 'red darken-2', action: 'toDisableEnable', code: 'ma.solicitud.disable-enable' },
          { title: 'Solicitud (PDF)', icon: 'mdi-clipboard-text', color: 'blue-grey lighten-1', action: 'PrintSolicitudPdf', code: 'ma.pdf-solicitud' },
          { title: 'Servicio (PDF)', icon: 'mdi-clipboard-text', color: 'blue-grey lighten-1', action: 'PrintPdf', code: 'ma.pdf' },
          { title: 'Insumos (PDF)', icon: 'mdi-clipboard-text', color: 'blue-grey lighten-1', action: 'PrintPdfInsumos', code: 'ma.pdf-insumos' }
        ],
        totalData: 0,
        pagination: {}
      },
      footer: { paging: true }
    },
    pages: {},
    item: {},
    exprecion: null,
    execute: false
  }),
  components: {
    // DataTable,
    DataTableServer,
    ViewDetails,
    MesaAyudaDialog,
    MesaAyudaTicketsDialog,
    MesaAyudaEditTicketsDialog
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.tableServer })
    // this.getDataUrl('ma.list')
    this.exprecion = this.$route.params.exprecion
  },
  methods: {
    ...mapActions(['getUrlServices', 'urlGetServicesActionList',
      'urlPostServicesActionPagination', 'urlPostServicesActionSecound', 'postExecuteAction', 'postUrlImportDataServerAction',
      'DeletePaginationServerAction']),
    // *==========*==========*==========* Methods Actions Table *==========*==========*==========* \\
    successAction (item) {
      this[item.action](item)
    },
    toCreateSolicitud () {
      this.item = {}
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 1000, title: 'Nueva Solicitud' })
    },
    refreshData (item) {
      this.tableServer.header.loading = true
      this.pages = item.pagination
      this.getDataUrl('ma.list-pagination')
    },
    // *==========*==========*==========* Methods Items Actions Table *==========*==========*==========* \\
    tableAction (item) {
      this[item.action](item)
    },
    toDisableEnable ({ item }) {
      const isActive = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.$swal.fire({
        title: `Estas seguro de ${isActive} el registro ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Si, ${isActive}!`,
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          const url = this.get_urls['ma.solicitud.disable-enable']
          this.DeletePaginationServerAction({ url: url, params: item.id, replace: '{id}' })
        }
      })
    },

    PrintPdf (item) {
      const router = this.get_urls['ma.pdf']
      this.postUrlImportDataServerAction({ url: router, data: item.item })
    },
    PrintPdfInsumos ({ item }) {
      if (item.last_movement.estatus_id === 20) {
        const router = this.get_urls['ma.pdf-insumos']
        this.postUrlImportDataServerAction({ url: router, data: item })
        return
      }
      this.$swal({
        type: 'warning',
        icon: 'warning',
        title: 'Advertencia !',
        text: 'El documento se debe imprimir cuando se haga la entrega de los insumos'
      })
    },
    PrintSolicitudPdf ({ item }) {
      const router = this.get_urls['ma.pdf-solicitud']
      this.postUrlImportDataServerAction({ url: router, data: item })
    },

    toAssign (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'assign', with: 450, title: 'Asignar Servicio' })
    },
    toEditRow (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'edit', with: 850, title: `Editar Solicitud - ${item.item.folio}` })
    },
    // *==========*==========*==========* Methods Table Pagination *==========*==========*==========* \\
    pagePagination (val) {
      this.tableServer.header.loading = true
      this.pages = val
      this.getDataUrl('ma.list-pagination')
    },
    getSearchPagePagination (val) {
      this.tableServer.header.loading = true
      this.pages = val
      this.getDataUrl('ma.list-pagination-search')
      // this.pages = val
    },
    /* *==========*==========*==========*==========*==========* */

    toDiagnosis (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'diagnosis', with: 600, title: 'Diagnósticar Equipo' })
    },
    toSendGeneralDirection (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'central', with: 600, title: 'Enviar Equipo a Direccion General' })
    },
    toService (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'service', with: 600, title: 'Reparación Equipo' })
    },
    toExit (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'exit', with: 600, title: 'Entregar Equipo' })
    },
    toAttend (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'attend', with: 600, title: 'Atender Servicio' })
    },
    toFinish (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'finish', with: 600, title: 'Finalizar Servicio' })
    },

    toExitInsumo (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'exitInsumo', with: 600, title: 'Salida de Insumos' })
    },
    toDeliveryInsumo (item) {
      this.item = item
      this.SHOW_DIALOG_MAIN({ type: 'delivery', with: 600, title: 'Entrega de Insumos' })
    },

    // *==========*==========*==========*==========*==========*==========* \\
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        // this.urlGetServicesActionList({ url: router })
        this.urlPostServicesActionPagination({ url: router, data: this.pages })
      } else {
        this.getUrlServices()
      }
    },
    ExportTodos (item) {
      this.getUrlExport('ma.export-list')
    },
    getUrlExport (objet) {
      const router = this.get_urls[objet]
      this.urlPostServicesActionSecound({ url: router, data: {} })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'UPDATE_MESA_AYUDA_SERVICES'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objectTwo', 'get_dialogMain', 'get_objectExport', 'get_objectPagination', 'get_reload']),
    object () {
      if (this.tableServer.modelMain.length > 0) {
        return this.tableServer.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      if (val) {
        this.getDataUrl('ma.list-pagination')
      }
    },
    get_objectTwo (vals) {
      if (vals) {
        console.log('vals', vals)
        const data = XLSX.utils.json_to_sheet(vals.data)
        const workbook = XLSX.utils.book_new()
        // const nameHours = this.getDateAndHour()
        const filename = vals.name
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      }
    },
    get_objectExport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      const linkSource = `data:application/pdf;base64,${val.pdf}`
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = val.nombre
      downloadLink.click()
    },
    get_objectPagination (val) {
      if (val) {
        this.tableServer.body.data = val.data
        this.tableServer.body.totalData = val.total
        if (val.data.length > 0) {
          this.tableServer.modelMain = []
          this.tableServer.modelMain.push(val.data[0])
        } else {
          this.tableServer.modelMain = []
        }
        this.tableServer.header.loading = false
        if (this.exprecion) {
          if (this.execute) return
          this.execute = true
          this.pages.search = this.exprecion
          this.getDataUrl('ma.list-pagination-search')
        }
      }
    },
    get_reload (val) {
      let findobject = -1
      this.tableServer.body.data.map((el, i) => {
        if (el.id === val.id) {
          findobject = i
        }
      })
      if (findobject !== -1) {
        Object.assign(this.tableServer.body.data[findobject], val)
      } else {
        this.getDataUrl('ma.list-pagination')
      }
    }
  }
}
</script>

<style></style>
